module.exports = __webpack_public_path__ + "img/float.26319f70.jpg";